import './index.scss';
import { useState } from 'react'
import SignatureCanvas from 'react-signature-canvas';
import { useRef } from 'react'
import { userInfo } from '../../../redux/slice.js';
import { useSelector } from 'react-redux';
import { post } from '../../../util/request.js';
import { Box, Button } from '@mui/material';
import Loading from '../../../components/common/loading.js';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import SubmitSuccessPopUp from '../../../components/page/submitSuccessPopUp';

export default ExitSummary; function ExitSummary({ VotingDetails, VotingResult, BusinessDetail }) {
    const user = useSelector(userInfo);
    const signatureCanvasRef = useRef(null);
    const [confirmButtonStatus, setConfirmButtonStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [signatureError, setSignatureError] = useState('');
    const history = useHistory();
    const { t } = useTranslation();

    function goDetail(url) {
        history.push({
            pathname: url
        });
    }

    function getBounds(strokes) {
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;

        strokes.forEach(stroke => {
            stroke.forEach(point => {
                if (point.x < minX) minX = point.x;
                if (point.x > maxX) maxX = point.x;
                if (point.y < minY) minY = point.y;
                if (point.y > maxY) maxY = point.y;
            });
        });

        return { minX, maxX, minY, maxY };
    }

    const handleClear = () => {
        signatureCanvasRef.current.clear();
        setConfirmButtonStatus(true);
        setSignatureError('');
    };

    const handleEnd = () => {
        let invalidSignature = true;
        const strokes = signatureCanvasRef.current?.toData();
        const { minX, maxX, minY, maxY } = getBounds(strokes);
        const height = maxY - minY;
        const width = maxX - minX;

        if (height > 130 && width > 20 && !signatureCanvasRef.current?.isEmpty()) {
            invalidSignature = false;
            setSignatureError('');
        } else {
            invalidSignature = true;
            setSignatureError('The signature does not meet the minimum size requirement. Kindly provide a larger signature.');
        }

        setConfirmButtonStatus(invalidSignature);
    }

    const handleConfirm = async () => {
        if (user.sfUserType === 'CL') {
            if (!signatureCanvasRef.current.isEmpty()) {
                setLoading(true);
                let params = {
                    accessToken: user.accessToken,
                    userId: user.userId,
                    headerRecId: VotingDetails.recId,
                    accountNumber: user.clientID,
                    isMobile: false,
                    businessAddressLine1: BusinessDetail?.addressLine1,
                    businessAddressLine2: BusinessDetail?.addressLine2,
                    businessPhone: BusinessDetail?.businessPhone,
                    businessEmail: BusinessDetail?.businessEmail,
                    clientOccupation: BusinessDetail?.occupation,
                }

                params.signatureImage = signatureCanvasRef.current.getCanvas().toDataURL('image/png').split(',')[1];
                params.result = VotingResult;

                await post('exitVoting/submitVote', params).then((data) => {
                    if (data.message === 'Success') {
                        setLoading(false);
                        setIsModalOpen(true);
                        setIsError(false);
                        sessionStorage.removeItem('votingTemplate');
                    }
                    else {
                        setConfirmButtonStatus(false);
                        setLoading(false);
                        setIsError(true);
                    }
                }).catch(() => {
                    setIsModalOpen(true);
                    setLoading(false);
                    setIsError(true);
                });
            }
            else {
                setConfirmButtonStatus(false);
                setLoading(false);
            }
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
        if (!isError) {
            sessionStorage.setItem('recId', '');
            goDetail('/home');
        }
    };

    return (
        <>
            {loading ? <Loading /> : null}
            <SubmitSuccessPopUp isModalOpen={isModalOpen} title={isError ? t('SUBMISSION ERROR') : t('submissionSuccessful_Vote')} content={isError ? t('Submission error. Please try again.') : t('Your vote has been successfully accepted.')} handleOk={handleOk} handleCancel={handleOk} icon={isError ? 'submit-error' : 'submit-success'} />
            <div className='stepper-content' >
                <div id="exit-summary-div">
                    <div className='row stepper-title'>
                        <p>
                            {t('Summary')}
                        </p>
                    </div>
                    <div className='row stepper-p exit-summary-content'>
                        <div>
                            <div className='offer-summary'>
                                <p className='stepper-title'>
                                    {t('Selected votes')}
                                </p>
                                <table className='ballot-table'>
                                    <thead>
                                        <tr>
                                            <th>{t('Ballot No.')}</th>
                                            <th>{t('Offer')}</th>
                                            <th>{t('Response')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            VotingResult.length !== 0 ? (
                                                VotingResult.map((result) => (<>
                                                    <tr>
                                                        <td>{result.optionSequence}</td>
                                                        <td>{result.offer}</td>
                                                        <td>
                                                            {
                                                                result.yesVoteUnit > 0 ? t('Accept the offer') : result.noVoteUnit > 0 ? t('Decline the offer') : t('Manual')
                                                            }
                                                        </td>
                                                    </tr>
                                                </>))
                                            ) : (<>
                                                <tr>
                                                    <td colSpan={3}>
                                                        {t('No selected votes')}
                                                    </td>
                                                </tr>
                                            </>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ lineHeight: "1" }}>
                                <p className='signature-title'>
                                    {t('Signature')}
                                </p>
                                <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                                    {VotingDetails?.udiCountry === 'CAN' ? t('Note_Signature_CAN') : t('Note_Signature')}
                                </p>

                                <p className='signature-instruction' style={{ fontSize: "18px", fontWeight: "bold", marginTop: "20px" }}>
                                    {t('Note_Signature_2')}
                                </p>
                            </div>
                            <div className='signature-container'>
                                <div className='signature-div'>
                                    <SignatureCanvas penColor='black' ref={signatureCanvasRef}
                                        canvasProps={{ className: 'sigCanvas', height: 300 }}
                                        onEnd={handleEnd}
                                        onBegin={() => setSignatureError('')}
                                        minWidth={2.5}
                                        maxWidth={4} />
                                </div>
                                <div className='clear-button-div'>
                                    <button className='btn ' onClick={handleClear}>{t('Clear')}</button>
                                </div>
                                {
                                    signatureError && (<>
                                        <div className='signature-error'>
                                            <p>
                                                {t(signatureError)}
                                            </p>
                                        </div>
                                    </>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='stepper-footer' style={{ marginTop: "-70px" }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button onClick={handleConfirm} disabled={user.sfUserType === 'CL' ? confirmButtonStatus : true}>{t('Confirm and Submit')}</Button>
                </Box>
            </div>
        </>
    );
}